import { BGImageProps } from '../components/BGImageCard';
import aetnaBG from '../assets/aetna.jpg';
import apolloBG from '../assets/apollo.jpg';
import earninBG from '../assets/earn-in.jpg';
import microsoftBG from '../assets/microsoft.jpg';
import revolutBG from '../assets/revolut.jpg';
import netflixBG from '../assets/netflix2.png';
import tableauBG from '../assets/tableau2.png';
import { getDataBySelector } from '../customerData';

export const heroCardData: BGImageProps[] = [
  {
    bgImage: netflixBG,
    gradientColor: 'purple',
    ...getDataBySelector('netflix'),
  },
  {
    bgImage: tableauBG,
    gradientColor: 'darkblue',
    ...getDataBySelector('tableau'),
  },
  {
    bgImage: revolutBG,
    gradientColor: 'purple',
    ...getDataBySelector('revolut'),
  },
  {
    bgImage: microsoftBG,
    gradientColor: 'orange',
    ...getDataBySelector('microsoft'),
  },
  {
    bgImage: apolloBG,
    gradientColor: 'blue',
    ...getDataBySelector('apollo'),
  },
  {
    bgImage: earninBG,
    gradientColor: 'yellow',
    ...getDataBySelector('earnin'),
  },
  {
    bgImage: aetnaBG,
    gradientColor: 'beige',
    ...getDataBySelector('aetna'),
  },
];
